module.exports = __webpack_public_path__ + "img/154.645462c1.svg";